import * as  React from 'react';
import {Pagination, Col, Button, Card, Row} from 'antd';
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {RequestData} from '@models/axios';
import {FormattedMessage} from 'react-intl';
import debounce from "lodash/debounce";


interface withPaginationComponentProps {
  count: number;
  fetchRequest: (requestData: RequestData) => any;
  location: object;
}

const withPaginationComponent = <P extends object>(Component: React.ComponentType<P>) =>
  class withPaginationComponent extends React.Component<P & withPaginationComponentProps> {
    
    state = {
      currentPage: 1
    };
  
    constructor(props) {
      super(props);
      this.fetchData = debounce(this.fetchData, 800);
    }
    
    componentDidMount() {
      this.props.initialFetch && this.fetchData(this.props.defaultPageFilter);
    }

    fetchData = (params = {}) => {
      this.props.fetchData(params)
    };
    
    search = (filter: object = {}) => {
      this.filter = filter;
      this.paginationParams = PaginationDefaultParams;
      this.fetchData(filter);
      this.setState({
        currentPage: 1
      })
    };
    
    onChangePage = (page: number, pageSize: number = PaginationDefaultParams.count): void => {
      this.setState({
        currentPage: page
      });
      this.paginationParams = {
        offset: (page - 1) * pageSize,
        count: pageSize
      };
      this.fetchData(this.paginationParams);
    };
    
    render() {
      return (
        <div>
          <Component
            {...this.props as P}
            currentPage={this.state.currentPage}
            search={this.search}
          />
          
          <Pagination
            size={`small`}
            current={this.state.currentPage}
            total={this.props.count}
            defaultPageSize={PaginationDefaultParams.count}
            showTotal={() => {
              return `تعداد کل: ${this.props.count}`; //TODO should be translate dynamically
            }}
            onChange={this.onChangePage}
          />
        </div>
      )
    }
  };

export default withPaginationComponent;